import React, { useContext, useEffect, useState } from 'react'
import InfoIcon from '@mui/icons-material/Info';
import './CardItem.css'
import UserContext from '../../contexts/UserContext';
import { addItemToFavorite, addItemToOrder, removeItemFromFavorite, removeItemFromOredr } from '../../service/apiServise';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { Clear, Done } from '@mui/icons-material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { FavoriteContext } from '../../contexts/FavoriteContext';
import { cartContext } from '../../contexts/CartContext';
import { OpenOrderContext } from '../../contexts/OpenOrderContext';
import { useNavigate } from 'react-router-dom';
import ImageLightbox from '../lightbox/ImageLightbox';

// categoryPath: when set (Home's preview lists pass e.g. "/chocolates"), the
// cart button no longer orders the item directly - it routes to the item's
// dedicated category page instead. That page owns the real ordering flow
// (for chocolates specifically, the box-size package-builder), which a
// direct add-to-order here would silently bypass.
function CardItem({ item, isFavoriteDefault, categoryPath }) {
    const { currentUser, isRequstToGetCurrentUserDone } = useContext(UserContext);
    const { toggleFavoriteContext } = useContext(FavoriteContext);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [zoomed, setZoomed] = useState(false);
    const [isFavorite, setIsFavorite] = useState(isFavoriteDefault);
    const { cartItems, addToCart, removeFromCart } = useContext(cartContext);
    const { openOrderItemIds, refreshOpenOrder, markInOrder } = useContext(OpenOrderContext);
    // "Already added" is derived from the real cart/order instead of a flag
    // local to this card - a local flag reset every time the card remounted,
    // so leaving the page and coming back showed the product as not added.
    const clicked = currentUser ? openOrderItemIds.has(item.id) : cartItems.includes(item.id);

    // Empty deps meant this only ever ran once, on mount - if the parent's
    // favorites list (fetched async) resolved AFTER this card already
    // rendered with isFavoriteDefault=false (the common case: products
    // render before the favorites lookup returns), the heart got stuck
    // unfilled forever even for genuinely favorited items. Re-sync whenever
    // the parent actually passes a new value.
    useEffect(() => {
        setIsFavorite(isFavoriteDefault);
    }, [isFavoriteDefault]);




    const toggleFavorite = async (id) => {
        // See the matching fix/comment in CardChocolate.jsx's toggleFavorite -
        // same missing isRequstToGetCurrentUserDone guard, same bug.
        if (!isRequstToGetCurrentUserDone) {
            return;
        }
        if(!currentUser){
            if(isFavorite){
             toggleFavoriteContext(id);
                setIsFavorite(false);
            }else{
             toggleFavoriteContext(id);
                setIsFavorite(true);
            }
        return;}
        try {

            if (isFavorite) {
                await removeItemFromFavorite(id);

                setIsFavorite(false);
            } else {
                await addItemToFavorite(id);

                setIsFavorite(true);
            }
        } catch (error) {
            if (error.response && error.response.data) {
                setError(error.response.data);
            }

            setTimeout(() => {
                setError("");
            }, 2000);
        }
    }

    // Home's preview cards (categoryPath set) lead to the category page;
    // everywhere else the image enlarges.
    const onImageClick = () => {
        if (categoryPath) {
            navigate(categoryPath);
        } else {
            setZoomed(true);
        }
    }

    const addToOrder = async () => {
        // Chocolates are only sold in fixed box sizes (see /chocolates'
        // package builder) - adding one directly here, one unit at a time,
        // bypassed that entirely. This is the generic "add to order" button
        // used from search results, favorites, and anywhere else CardItem
        // renders a chocolate without an explicit categoryPath - route it to
        // the builder unconditionally rather than relying on every call site
        // to remember to pass one.
        const targetPath = categoryPath || (item.category === 'chocolate' ? '/chocolates' : null);
        if (targetPath) {
            navigate(targetPath);
            return;
        }
        if (currentUser === null) {
            addToCart(item.id);
            return;
        }

        try {
            await addItemToOrder(item.id);
            markInOrder(item.id);
            refreshOpenOrder();
        } catch (error) {
            if (error.response && error.response.data) {
                setError(error.response.data);

                setTimeout(() => {
                    setError("");
                }, 3000);
            }
        }
    }

    const removeFromOrder = async () => {
        // A guest's items live in the local cart, not in an order on the
        // server - calling the order API here could only ever fail for them.
        if (currentUser === null) {
            removeFromCart(item.id);
            return;
        }
        try {
            await removeItemFromOredr(item.id);
            refreshOpenOrder();
        } catch (error) {
            if (error.response && error.response.data) {

                setError(error.response.data);

                setTimeout(() => {
                    setError("");
                }, 3000);
            };
        }
    }


    return (
        <div className="wrapper" key={item.id} >
            <div className="container" >
                <div className="top clickable" role="button" tabIndex={0} aria-label={item.name} style={{ "--bg-url": `url(${item.image})` }} onClick={onImageClick} onKeyDown={(e) => { if (e.target === e.currentTarget && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); onImageClick(); } }}>  <div onClick={(e) => { e.stopPropagation(); toggleFavorite(item.id); }}> {isFavorite ? <FavoriteIcon className='icon' /> : <FavoriteBorderIcon className='icon' />} </div> </div>
                <div className={`bottom ${clicked ? 'clicked' : ''}`}>
                    <div className="left">
                        <div className="details">
                            {error && <div className="error">{error}</div>}
                            <h3>{item.name} </h3>
                            <h3>₪{item.price}</h3>
                        </div>

                        <div>
                            <div className='buy' onClick={addToOrder}><AddShoppingCartIcon className='icon' /> </div>
                        </div>

                    </div>

                    <div className="error">{error}</div>
                    <div className="right">
                        <div className="done"><Done className='icon' /></div>
                        <div className="details">
                            <h3>{item.name}</h3>

                        </div>
                        <div className="remove" onClick={removeFromOrder}>
                            <Clear className='icon' /></div>
                    </div>
                </div>
            </div>
            <div className="inside">
                <div className="icon"><InfoIcon /></div>
                <div className="contents">
                    <h4>מידע: {item.description}</h4>
                    <h4>טיבעוני: {item.veg ? 'כן' : 'לא'}</h4>

                </div>
            </div>
            {zoomed && <ImageLightbox src={item.image} alt={item.name} onClose={() => setZoomed(false)} />}
        </div>
    )


}
export default CardItem
